import { render, staticRenderFns } from "./FullscreenIcon.vue?vue&type=template&id=3c9ed529&"
import script from "./FullscreenIcon.vue?vue&type=script&lang=js&"
export * from "./FullscreenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports